import styled from 'styled-components';

export const PanelContainer = styled.div`
  width: 280px;
  min-width: 280px;
  height: 100%;
  padding: 24px;

  display: flex;
  flex-direction: column;
  row-gap: 24px;

  overflow-y: auto;

  background-color: ${({ theme }) => theme.colors.greys.lightest};
  border-radius: 8px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
`;

export const PanelTitle = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export const PanelTitleIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const CommentBlock = styled.div`
  flex: 1;
  min-height: 160px;

  display: flex;
  flex-direction: column;
  row-gap: 8px;

  /* The lib Textarea wraps the field in its own div: it has to stretch too, or the field would
  stay at its minimum height and leave the bottom of the panel empty. */
  > div:last-child {
    flex: 1;

    display: flex;
    flex-direction: column;
  }

  textarea {
    flex: 1;
    height: 100%;
    min-height: 160px;
    resize: none;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;

  background-color: ${({ theme }) => theme.colors.greys.light};
`;
